/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import {
  getCache,
  setCache,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";

const basePath = `${referenceService}`;

export const getKategoriBelanja = async () => {
  const cached = getCache("kategori-belanja");
  if (cached) return cached;

  const response = await api.get(`${basePath}/kategori-belanja`, {
    params: {
      activated: 1,
    },
  });
  const data = response?.data?.return;
  if (data) setCache("kategori-belanja", data);
  return data;
};

export const postKategoriBelanja = async (params: any) => {
  const response = await api.post(`${basePath}/kategori-belanja`, params, {
    headers: { "Content-Type": "application/json" },
  });
  removeCacheByPrefix("kategori-belanja");
  return response?.data?.return;
};

export const deleteKategoriBelanja = async (params: any) => {
  const response = await api.delete(`${basePath}/kategori-belanja/${params}`);
  removeCacheByPrefix("kategori-belanja");
  return response?.data?.return;
};

export const postJenisBelanja = async (params: any) => {
  const response = await api.post(`${basePath}/jenis-belanja`, params, {
    headers: { "Content-Type": "application/json" },
  });
  removeCacheByPrefix("kategori-belanja");
  return response?.data?.return;
};

export const deleteJenisBelanja = async (params: any) => {
  const response = await api.delete(`${basePath}/jenis-belanja/${params}`);
  removeCacheByPrefix("kategori-belanja");
  return response?.data?.return;
};
